/**
 * @generated SignedSource<<8cd99338c88418089bbb22648c6dec66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartSageIntacctRecipesInput = {
  sageIntacctTimeRegsFromForecast?: boolean | null;
  sageServiceForTimeRegsFeatureFlag?: boolean | null;
  sageServiceForTasksFeatureFlag?: boolean | null;
  sageServiceForProjectsFeatureFlag?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type startSageIntacctRecipesMutation$variables = {
  input: StartSageIntacctRecipesInput;
};
export type startSageIntacctRecipesMutation$data = {
  readonly startSageIntacctRecipes: {
    readonly outcome: string | null;
  } | null;
};
export type startSageIntacctRecipesMutation = {
  variables: startSageIntacctRecipesMutation$variables;
  response: startSageIntacctRecipesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "startSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71e0ab5012d8fa1c4436207f226305b8",
    "id": null,
    "metadata": {},
    "name": "startSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation startSageIntacctRecipesMutation(\n  $input: StartSageIntacctRecipesInput!\n) {\n  startSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();

(node as any).hash = "ccfb72ca74df6552fcd29d748b71a1cf";

export default node;
